module.exports = __webpack_public_path__ + "img/human_music.2fefa931.jpg";